const handlePageLeave = (state) => {
    // NOTE: Redefine window.confirm method to use custom modal
    // component instead of browser's default 20221219:Alevale
    window.confirm = () => true;

    // NOTE: In some places we have to bypass the block navigation
    // in case there's redirects or other kind of logic
    // that go hand in hand with normal user actions 20221222:Alevale
    if (state.blockNavigation?.bypassBlockNavigation) {
        return false;
    }
    return 'leavingPageConfirmation';
};

const appId = window.routeSettings.appRoute;
const serviceRequestRoles = ['Viewer', 'Purchaser', 'Viewer_Lite', 'Internal_Purchaser'];
const routesMap = {
    HOME: `/apps/${appId}/`,
    USER: `/apps/${appId}/user`,
    CATALOG: `/apps/${appId}/catalog`,
    PRODUCTDETAILS: `/apps/${appId}/productdetails`,
    CART: `/apps/${appId}/cart`,
    RETURNCART: `/apps/${appId}/returnCart`,
    MANAGETEMPLATES: `/apps/${appId}/manageTemplates`,
    MANAGETEMPLATEDETAILS: `/apps/${appId}/manageTemplateDetails`,
    ORDERDETAILS: `/apps/${appId}/orderdetails`,
    ORDERHISTORY: `/apps/${appId}/orderHistory`,
    ORDERVISIBILITY: `/apps/${appId}/orderVisibility`,
    RMAHISTORY: `/apps/${appId}/rmaHistory`,
    CHECKOUT: `/apps/${appId}/checkout`,
    DELIVERYNOTERETRIEVAL: `/apps/${appId}/deliverynoteretrieval`,
    ORDERCONFIRMATION: `/apps/${appId}/orderconfirmation`,
    INVOICEHISTORY: `/apps/${appId}/invoiceHistory`,
    ACCOUNTFINANCIALINFO: `/apps/${appId}/accountfinancialinformation`,
    USERGUIDES: `/apps/${appId}/userGuides`,
    RETURNSPOLICY: `/apps/${appId}/returnsPolicy`,
    PRIVACYPOLICY: `/apps/${appId}/privacyPolicy`,
    CONTACTUS: `/apps/${appId}/contactUs`,
    POPENDING: `/apps/${appId}/popending`,
    FINDMYSALESREP: `/apps/${appId}/findMySalesRep`,
    INVENTORYCHECKIN: `/apps/${appId}/inventorycheckin`,
    INVENTORYCHECKOUT: `/apps/${appId}/inventorycheckout`,
    INVENTORY: `/apps/${appId}/inventory`,
    SCANDASHBOARD: `/apps/${appId}/scan-dashboard`,
    CYCLECOUNT: `/apps/${appId}/cyclecount`,
    MANAGEFOUND: `/apps/${appId}/managefound`,
    MANAGEMISSING: `/apps/${appId}/manageMissing`,
    SUPPORTPAGE: `/apps/${appId}/supportpage`,
    REPORTORDERDISCREPANCY: `/apps/${appId}/order-discrepancy`,
    BILLANDREPLACE: `/apps/${appId}/billAndReplace`,
    RMADETAIL: `/apps/${appId}/rmaDetail`,
    TRANSACTION: `/apps/${appId}/transaction`,
    CONSIGNMENTADD: `/apps/${appId}/consignmentAdd`,
    SAMPLEFROMCONSIGNMENT: `/apps/${appId}/sampleFromConsignment`,
    SAMPLESHIPTOACCOUNT: `/apps/${appId}/sampleShipToAccount`,
    DRAFTORDERS: `/apps/${appId}/draftOrders`,
    RMAREQUEST: `/apps/${appId}/rmarequest`,
    CREATERMA: `/apps/${appId}/createrma`,
    TERMSANDCONDITIONS: `/apps/${appId}/termsAndConditions`,
    HELP: `/apps/${appId}/help`,
    FAQ: `/apps/${appId}/faqs`,
    INVENTORYSPECIALCHECKIN: `/apps/${appId}/inventorySpecialCheckin`,
    RETURNHISTORY: `/apps/${appId}/returnableOrders`,
    WARRANTYDASHBOARD: `/apps/${appId}/warrantyDashboard`,
    NEWWARRANTYCLAIM: `/apps/${appId}/newWarrantyClaim`,
    TRAINING: `/apps/${appId}/training`,
    CLAIMSUBMISSION: `/apps/${appId}/claimSubmission`,
    WARRANTYCLAIMDETAILS: `/apps/${appId}/warrantyClaimDetails`,
    WARRANTYREPORTING: `/apps/${appId}/warrantyReporting`,
    CLAIMAUTHORIZATION: `/apps/${appId}/claimAuthorization`,
    OUTSTANDINGINVOICES: `/apps/${appId}/outstandingInvoices`,
    ITCINVOICEHISTORY: `/apps/${appId}/ITCInvoiceHistory`,
    DISPUTES: `/apps/${appId}/disputes`,
    AGEINGSUMMARY: `/apps/${appId}/ageingSummary`,
    ITCHISTORYREPORT: `/apps/${appId}/ITCHistoryReport`,
    ITCACCOUNTSTATEMENT: `/apps/${appId}/ITCAccountStatement`,
    DISPUTEDETAILS: `/apps/${appId}/disputeDetails`,
    ITCPAYMENTUSAGEDETAIL: `/apps/${appId}/ITCPaymentUsageDetail`,
    SALESOUTDASHBOARD: `/apps/${appId}/salesOutDashboard`,
    ACCOUNTINVOICEDETAIL: `/apps/${appId}/accountInvoiceDetail`,
    MANAGESUBMISSIONS: `/apps/${appId}/manageSubmissions`,
    ENDCUSTOMER: `/apps/${appId}/endCustomer`,
    RETURNCHECKOUT: `/apps/${appId}/returnCheckout`,
    SUBMISSIONDETAIL: `/apps/${appId}/submissionDetail`,
    CUSTOMERADMIN: `/apps/${appId}/customerAdmin`,
    SALESOUTRECORD: `/apps/${appId}/salesOutRecord`,
    SUBMISSIONACCURACY: `/apps/${appId}/submissionAccuracy`,
    INVENTORYRECORD: `/apps/${appId}/inventoryRecord`,
    ENDCUSTOMERRECORD: `/apps/${appId}/endCustomerRecord`,
    SUBMISSIONSTATUSREPORT: `/apps/${appId}/submissionStatusReport`,
    SERVICEREQUEST: `/apps/${appId}/serviceRequest`,
    SERVICEREQUESTDETAILS: {
        path: `/apps/${appId}/serviceRequestDetails`,
        thunk: (dispatch, getState) => {
            const access = getState()?.AccountDetails?.user.access || [];
            const userRoles = getState()?.meDetails?.roles || [];
            const hasAccessToServiceRepair =
                access.length > 0 &&
                !!access.find(
                    (app) =>
                        app.appId === 'CENT' &&
                        app.roles.find(
                            (role) => role.permissions && role.permissions.includes('ServiceRepair')
                        )
                );
            const validRoles = serviceRequestRoles.some((role) => userRoles.includes(role));
            if (!hasAccessToServiceRepair || !validRoles) {
                const prevPath = getState()?.location?.prev.type;
                prevPath ? dispatch({ type: prevPath }) : dispatch({ type: 'HOME' });
            }
        },
    },
    RAISEDISPUTE: {
        path: `/apps/${appId}/raiseDispute`,
        shouldPromptLeaveConfirmation: true,
    },

    REGISTERCONSUMPTION: {
        path: `/apps/${appId}/registerConsumption`,
        shouldPromptLeaveConfirmation: true,
    },
    CONSUMPTIONSUMMARY: `/apps/${appId}/consumptionSummary`,
    REPORTSTOCKDISCREPANCY: {
        path: `/apps/${appId}/reportStockDiscrepancy`,
        shouldPromptLeaveConfirmation: true,
    },
    REPORTDISCREPANCYSUMMARY: `/apps/${appId}/reportDiscrepancySummary`,
    ORDERSPENDINGAPPROVAL: {
        path: `/apps/${appId}/ordersPendingApproval`,
        shouldPromptLeaveConfirmation: true,
    },
    EQUIPMENTOVERVIEW: `/apps/${appId}/equipmentOverview`,
    EQUIPMENTDETAILS: `/apps/${appId}/equipmentDetails`,
    ACUTECAREMONITORING: `/apps/${appId}/acuteCareMonitoring`,
    NEWSERVICEREQUEST: {
        path: `/apps/${appId}/newServiceRequest`,
        shouldPromptLeaveConfirmation: true,
    },
};

Object.keys(routesMap).forEach((key) => {
    const route = routesMap[key];
    if (route.shouldPromptLeaveConfirmation) {
        route.confirmLeave = handlePageLeave;
    }
});

export default routesMap;
